import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import config from 'constants/config'
import { getTour2027LaunchCampaignTier, isTour2027LaunchCampaignActive } from 'constants/tours'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const StyledTour2027TravelTagLabel = styled(PromotionLabel)`
  &&&.kind-tertiary.variant-highlight {
    background-color: ${props => props.theme.palette.messaging.success.normalForeground};
    border-color: ${props => props.theme.palette.messaging.success.normalForeground};
    color: #fff;
  }

  &&&.kind-tertiary.variant-highlight > svg,
  &&&.kind-tertiary.variant-highlight > * {
    color: #fff;
  }
`

interface Props {
  className?: string
  tourId: string
}

function Tour2027TravelTagLabel({ className, tourId }: Props) {
  const intl = useIntl()
  const region = useAppSelector(state => state.geo.currentRegionCode)

  if (!isTour2027LaunchCampaignActive(region, config.BRAND)) {
    return null
  }

  const tier = getTour2027LaunchCampaignTier(tourId, intl)

  if (!tier) {
    return null
  }

  return <StyledTour2027TravelTagLabel className={className} icon={<LinePlaneDepartureIcon />} variant="default">{tier.tag}</StyledTour2027TravelTagLabel>
}

export default Tour2027TravelTagLabel
